import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/data/content";
import { Link } from "react-router-dom";

export default function FAQSection({ hideHeader = false, limit = null }) {
  const items = limit ? FAQS.slice(0, limit) : FAQS;
  return (
    <section data-testid="faq-section" className="py-20 md:py-28 bg-[var(--maqam-surface)]">
      <div className="max-w-4xl mx-auto px-5 md:px-8">
        {!hideHeader && (
          <div className="text-center">
            <span className="overline">Common Questions</span>
            <h2 className="font-serif text-4xl md:text-5xl text-navy mt-3 leading-[1.05] tracking-tight">
              Frequently Asked Questions
            </h2>
          </div>
        )}

        <Accordion type="single" collapsible className={`${hideHeader ? "" : "mt-12"} w-full`}>
          {items.map((f, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-b border-[var(--maqam-border)]"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="text-left py-6 font-serif text-lg md:text-xl text-navy hover:no-underline"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[var(--maqam-muted)] leading-relaxed pb-6 text-base">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {limit && FAQS.length > limit && (
          <div className="mt-8 text-center">
            <Link
              to="/faq"
              data-testid="faq-see-all-link"
              className="inline-flex items-center gap-2 text-sm font-semibold text-[color:var(--maqam-navy)] underline underline-offset-4 decoration-[color:var(--maqam-gold)] hover:decoration-2"
            >
              See all {FAQS.length} questions →
            </Link>
          </div>
        )}
      </div>
    </section>
  );
}
